import { render, staticRenderFns } from "./CmgLeaderboardCyoPanel.vue?vue&type=template&id=0aaa9140&scoped=true&lang=pug"
import script from "./cmg-leaderboard-cyo-panel.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-cyo-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardCyoPanel.vue?vue&type=style&index=0&id=0aaa9140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaa9140",
  null
  
)

export default component.exports